import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";

const GET_POPULAR_BRANDS = gql`
  query GetPopularBrands {
    getPopularKeywordsByFilterCached {
      popularBrands {
        id
        name_kr
        name
        resizedSmallLogo
      }
    }
  }
`;

const GET_TRENDING_BRANDS = gql`
  query GetTrendingBrands {
    getPopularKeywordsByFilterCached {
      trendingBrands {
        id
        name_kr
        name
        resizedSmallLogo
      }
    }
  }
`;

/**
 * 브랜드 정보 가져오기
 */
export const usePopularBrands = (type = "popular") => {
  const { loading, error, data } = useQuery(
    type === "popular" ? GET_POPULAR_BRANDS : GET_TRENDING_BRANDS,
  );

  return { loading, error, data };
};
